import { SxProps } from '@mui/material';

import { CustomTableVariant } from '@/components/table/CustomTable.comp.tsx';
import { themeColors } from '@/config/theme/themeColors.ts';

export const CustomTableListViewBoxStyles: SxProps = {
  alignItems: 'center',
  color: themeColors.greyDark,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  px: 2,
  py: 10,
};

export const CustomTableViewWrapperStyles = {
  mx: 'auto',
  width: '100%',
};

export const CustomTableViewWrapperPaperStyles = (params: {
  size?: CustomTableVariant;
}): SxProps => ({
  padding: params.size === 'small' ? '12px 16px' : '16px 24px',
});
